// Mapping nama properti internal -> CSS transform function
function transformStringFromValue(prop, value, transform) {
  const t = { ...transform };
  switch (prop) {
    case "position":
      t.x = value.x;
      t.y = value.y;
      break;
    case "rotate":
      t.rotate = value;
      break;
    case "scale":
      t.scaleX = value.x ?? value;
      t.scaleY = value.y ?? value;
      break;
    case "skew":
      t.skewX = value.x ?? value;
      t.skewY = value.y ?? value;
      break;
    default:
      break;
  }
  return `translate(${t.x}px, ${t.y}px) rotate(${t.rotate}deg) scale(${t.scaleX}, ${t.scaleY}) skew(${t.skewX}deg, ${t.skewY}deg)`;
}

/**
 * Export keyframeData jadi string CSS siap pakai.
 * keyframeData: { [elId]: { rotate: [{time, value, easing}], position: [...], ... } }
 * duration: total durasi animasi dalam detik
 */
export function exportToCSS(keyframeData, duration) {
  let css = "";

  Object.entries(keyframeData).forEach(([elId, props]) => {
    const propNames = Object.keys(props).filter((p) => props[p]?.length);
    if (!propNames.length) return;

    // kumpulkan semua timestamp unik dari semua properti elemen ini
    const allTimes = new Set();
    propNames.forEach((p) => props[p].forEach((kf) => allTimes.add(kf.time)));
    const sortedTimes = Array.from(allTimes).sort((a, b) => a - b);

    // base transform, di-update tiap kita lewatin timestamp
    let runningTransform = {
      x: 0, y: 0, rotate: 0, scaleX: 1, scaleY: 1, skewX: 0, skewY: 0,
    };

    let easingNote = "";
    const blocks = sortedTimes.map((time) => {
      const pct = duration > 0 ? ((time / duration) * 100).toFixed(1) : 0;

      propNames.forEach((prop) => {
        const kf = props[prop].find((k) => k.time === time);
        if (kf) {
          runningTransform = applyPropToTransform(prop, kf.value, runningTransform);
          if (kf.easing) easingNote = kf.easing;
        }
      });

      const transformStr = `translate(${runningTransform.x}px, ${runningTransform.y}px) rotate(${runningTransform.rotate}deg) scale(${runningTransform.scaleX}, ${runningTransform.scaleY}) skew(${runningTransform.skewX}deg, ${runningTransform.skewY}deg)`;

      return `  ${pct}% { transform: ${transformStr}; }`;
    });

    css += `@keyframes anim-${sanitizeId(elId)} {\n${blocks.join("\n")}\n}\n\n`;
    css += `#${sanitizeId(elId)} {\n`;
    css += `  transform-box: fill-box;\n`;
    css += `  transform-origin: center;\n`;
    css += `  animation: anim-${sanitizeId(elId)} ${duration}s ${mapEasingToCSS(easingNote)} infinite;\n`;
    css += `}\n\n`;
  });

  return css || "/* Belum ada keyframe untuk di-export. Tambahkan keyframe di timeline dulu. */";
}

function applyPropToTransform(prop, value, transform) {
  const t = { ...transform };
  if (prop === "position") {
    t.x = value.x;
    t.y = value.y;
  } else if (prop === "rotate") {
    t.rotate = value;
  } else if (prop === "scale") {
    t.scaleX = value.x ?? value;
    t.scaleY = value.y ?? value;
  } else if (prop === "skew") {
    t.skewX = value.x ?? value;
    t.skewY = value.y ?? value;
  }
  return t;
}

function sanitizeId(id) {
  return id.replace(/[^a-zA-Z0-9_-]/g, "-");
}

// easing GSAP-style -> perkiraan terdekat CSS timing-function
function mapEasingToCSS(easing) {
  const map = {
    "power1.inOut": "ease-in-out",
    "power1.in": "ease-in",
    "power1.out": "ease-out",
    "power2.inOut": "cubic-bezier(0.45, 0, 0.55, 1)",
    "linear": "linear",
    "bounce.out": "cubic-bezier(0.68, -0.55, 0.27, 1.55)",
    "elastic.out": "cubic-bezier(0.68, -0.6, 0.32, 1.6)",
  };
  return map[easing] || "ease-in-out";
}
